<template>
  <div class="row response_table">
     <table>
      <thead>
        <tr>
          <th>{{ translate('task.id') }}</th>
          <th>{{ translate('task.device_fid') }}</th>
          <th>{{ translate('task.command') }}</th>
          <th>{{ translate('task.status') }}</th>
          <th>{{ translate('task.username') }}</th>
          <th>{{ translate('task.ts') }}</th>
        </tr>
      </thead>
      <tbody
        ref="tableTask"
        @scroll.passive="paint_chart($event)"
      >
        <tr v-for="(task, key) in tasks" :key="key">
          <td :data-label="translate('task.id')">
            {{ task.id }}
          </td>
          <td :data-label="translate('task.device_fid')">
            <router-link :to="{path: '/device/' + task.device_fid}" class="link">
              {{ task.device_fid }}
            </router-link>
          </td>
          <td :data-label="translate('task.command')">
            {{ task.command }}
          </td>
          <td :data-label="translate('task.status')">
            {{ task.status }}
          </td>
          <td :data-label="translate('task.username')">
            <router-link :to="{path: '/usermanagment/users/@' + task.username}" class="link">
              {{ task.username }}
            </router-link>
          </td>
          <td :data-label="translate('task.ts')">
            {{ get_date(task.ts) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

export default {
  name: 'All_Tasks',
  data () {
    return {
      tasks: [],
      pages: 0,
      cur_page: 1,
      next_page: 0,
      after_load: false,
    }
  },
  created () {
    this.getTasks()
  },
  watch:{
    tasks(){
      this.after_load = false
    }
  },
  methods: {
    getTasks(){
      this.$http.v1.getTasks(this.cur_page,(response) => {
        if (response.data){
          this.pages = response.data.pages
          this.cur_page = response.data.current_page
          this.next_page = response.data.next_page
          this.tasks = response.data.tasks
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    paint_chart () {
      let table = this.$refs.tableTask
      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight*1.1)) && !this.after_load) {
        if (this.cur_page < this.pages) {
          this.add_task_in_list()
        }
      }
    },
    add_task_in_list () {
      if (this.cur_page < this.pages && this.next_page) {
        this.after_load = true
        this.$http.v1.getTasks(this.next_page,(response) => {
          if (response.status){
            this.pages = response.data.pages
            this.cur_page = response.data.current_page
            this.next_page = response.data.next_page
            this.tasks = [...this.tasks, ...response.data.tasks]
          }else{
            this.global_notify('danger', this.translate('no_data'))
          }
        })
      }
    },
  }
}

</script>
<style>

</style>
